import { userAtom } from '@/global-store';
import fetchWrapper from '@/http/fetchWrapper';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { api } from '@http/constants';
import { useMutation } from '@tanstack/react-query';
import { useNotification } from '@eye-able/ui';
import { useAtomValue } from 'jotai';

export interface PostOfferRequestResponse {
  message: string;
}

export function usePostOfferRequest() {
  const { t, i18n } = useInlineTranslation();
  const notification = useNotification();
  const user = useAtomValue(userAtom);
  const resolvedLanguage =
    typeof i18n.resolvedLanguage === 'string'
      ? i18n.resolvedLanguage
      : undefined;
  const userMailLanguage =
    user && 'mailLang' in user ? user.mailLang : undefined;

  return useMutation({
    mutationFn: (message: string) =>
      fetchWrapper.post<PostOfferRequestResponse>(api.offerRequest, {
        mailLang: userMailLanguage || resolvedLanguage,
        comment: message,
      }),
    onSuccess: () => {
      notification.success(t('supportRequestSent'));
    },
  });
}
